<template>
    <div id="go_PassengerInfoForm">
      <v-form>
          <v-container class="pt-0 pb-0">
            <v-layout row wrap style="border-top:solid 2px #f0f3f5;">
                <v-flex xs3 sm3 md2 style="padding: 8px 0px 8px 8px;" align-self-center>
                    <h3>{{decodePassengerType(passenger.passengerTypeCode) + " " + 
                      passenger.passengerNoByType}}</h3>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs7 sm7 md3 text-sm-right align-self-center 
                  style="margin-top:0px;" text-xs-right>
                    <span style="font-size:15px;">Use as contact info.</span>                  
                </v-flex>                
                <v-flex xs2 sm2 md1 text-sm-right>
                    <input type="hidden" :value="validationWatcher"/>
                    <v-switch
                        v-model="passenger.isContactPerson"
                    ></v-switch>                    
                </v-flex>                
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                    <v-alert
                        v-model="validation.showAlert"
                        type="error"
                    >
                    {{validation.message}}
                    </v-alert>       
                </v-flex>            
            </v-layout>
            <v-layout row wrap>          
                <v-flex xs12 sm6 md4>
                    <div id="divFirstName">
                        <v-text-field
                            label="* First Name / Given Name"
                            :rules="[rules.required,rules.azAZSpace,rules.counter50]"
                            maxlength="50"
                            outline
                            v-model="passenger.firstName"
                            :background-color="helper.colors.required"
                        ></v-text-field>           
                    </div>        
                </v-flex>             
                <v-flex xs12 sm6 md4>
                    <div id="divMiddleName">
                        <v-text-field
                            label="Middle Name"
                            :rules="[rules.azAZSpace]"
                            maxlength="50"
                            v-model="passenger.middleName"
                            outline
                        ></v-text-field>      
                    </div>            
                </v-flex>    
                <v-flex xs12 sm6 md4>
                    <div id="divLastName">
                        <v-text-field
                            label="* Last Name"
                            :rules="[rules.required,rules.azAZSpace]"
                            v-model="passenger.lastName"
                            maxlength="50"
                            outline
                            :background-color="helper.colors.required"
                        ></v-text-field>
                    </div>                   
                </v-flex>                                           
            </v-layout>
            <v-layout row wrap>   
                <v-flex xs12 sm12 md4>
                    <div id="go_PassengerTitleSelect">
                    <div v-if="!isMobile" class="pl-2">Other personal Info.</div>
                    <v-select
                    :items="viewModels.titleList"
                    label="* Title"
                    outline
                    v-model="passenger.title"
                    :background-color="helper.colors.required"
                    ></v-select>
                    </div>
                </v-flex>                                
                <v-flex xs12 sm12 md8>
                    <DateInput :label="((passenger.passengerTypeCode!='ADT')? '* ':'') + 
                      'Date of birth'" @emDateValue="d=>birthday=d" 
                      :required="(passenger.passengerTypeCode!='ADT')"/>
                </v-flex>       
                                          
            </v-layout>    
            <v-layout row wrap v-if="passenger.isContactPerson">
                <v-flex>
                    <div id="divPhone">
                        <v-text-field
                            v-model="passenger.phoneNo"
                            label="* Phone NO."
                            :rules="[rules.required,rules.azAZNumSpace]"
                            maxlength="20"
                            outline
                            :background-color="helper.colors.required"
                        ></v-text-field> 
                    </div>                     
                </v-flex>
                <v-flex>
                    <div id="divEmail">
                        <v-text-field
                            v-model="passenger.email"
                            label="* Email Address"
                            :rules="[rules.required, rules.email]"
                            maxlength="50"
                            outline
                            :background-color="helper.colors.required"
                        ></v-text-field>      
                    </div>                
                </v-flex>   
                <v-flex>
                    <v-textarea
                        outline
                        v-model="passenger.address"
                        name="input-7-4"
                        label="Address"
                        maxlength="250"
                        value=""
                    ></v-textarea>                    
                </v-flex>                             
            </v-layout>
            <v-layout row wrap v-if="passenger.passportRequired">
                
                <v-flex xs12 sm12 md4>
                    <div v-if="!isMobile" class="pl-2">Passport information</div>
                    <v-select
                    :items="countries"
                    label="Passport country"
                    outline
                    ></v-select>                    
                </v-flex>
                <v-flex xs12 sm12 md8>
                    <DateInput label="Date of expiration"/>
                </v-flex>  
                <v-flex xs12 sm12 md12>
                    <v-text-field
                        label="Passport Number"
                        maxlength="20"
                        outline
                    ></v-text-field>  
                </v-flex>                               
            </v-layout>
            <v-layout row wrap>
                <v-flex>
                    <div id="go_SpecialRequest">
                        <v-expansion-panel style="box-shadow:none;-webkit-box-shadow:none;">
                        <v-expansion-panel-content>
                            <template v-slot:header>
                              <div style="font-weight:bold;">Seat, Meal and Flyer Program</div>
                            </template>
                            <v-card>
                                <v-form>
                                    <v-container class="pl-0 pr-0">
                                    <v-layout row wrap>
                                            <v-flex xs12 sm12 md6>
                                                <v-select
                                                :items="viewModels.mealList"
                                                label="Meal preference"
                                                outline
                                                v-model="passenger.meal"
                                                clearable
                                                ></v-select>                                                                     
                                            </v-flex>          
                                            <v-flex xs12 sm12 md6>
                                                <v-select
                                                :items="viewModels.seatList"
                                                label="Seat preference"
                                                outline
                                                v-model="passenger.seatPreference"
                                                clearable
                                                ></v-select>                                                                     
                                            </v-flex>                                                        
                                        </v-layout>                                    
                                        <v-layout row wrap>
                                            <v-flex xs12 sm12 md6>
                                                <v-autocomplete
                                                    v-model="passenger.fqFlyerProgramAirline"
                                                    :items="viewModels.airlineList"
                                                    item-value="value"
                                                    item-text="text"
                                                    persistent-hint
                                                    outline
                                                    clearable
                                                    label="Frequent flyer program airline"
                                                >
                                                    <template v-slot:append-outer>
                                                    <v-slide-x-reverse-transition
                                                        mode="out-in"
                                                    >
                                                    </v-slide-x-reverse-transition>
                                                    </template>
                                                </v-autocomplete>                                                                                                                   
                                            </v-flex>
                                            <v-flex xs12 sm12 md6>
                                                <div id="divFreqFlyerNo">
                                                    <v-text-field
                                                        label="Frequent flyer number"
                                                        outline
                                                        v-model="passenger.fqFlyerNo"
                                                    ></v-text-field>         
                                                </div>                                                               
                                            </v-flex>                        
                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card>
                        </v-expansion-panel-content>
                        </v-expansion-panel>                     
                    </div>
  
                </v-flex>
            </v-layout>
                 
          </v-container>
      </v-form>
    </div>
</template>

<script>
import Passenger from './Passenger.code.js'
export default Passenger;
</script>

<style>
#divFreqFlyerNo > div > div > div.v-input__slot > div > input[type=text],
#divPhone > div > div > div.v-input__slot > div > input[type=text],
#divEmail > div > div > div.v-input__slot > div > input[type=text],
#divLastName > div > div > div.v-input__slot > div > input[type=text],
#divMiddleName > div > div > div.v-input__slot > div > input[type=text],
#divFirstName > div > div > div.v-input__slot > div > input[type=text]{
    text-transform: uppercase;
}
#go_PassengerInfoForm> .v-form > .container > .layout > .flex{
    padding: 0px 2px 0px 2px;
}
#go_PassengerInfoForm .v-text-field input{
    padding: 0px 0 0px
}
#go_PassengerInfoForm .v-text-field.v-text-field--enclosed .v-text-field__details{
    margin-bottom: 0px;
}
#go_PassengerTitleSelect > div.v-input.v-text-field > div > div.v-input__slot{
    height: 56px;
}
#go_SpecialRequest > ul > li > div.v-expansion-panel__header{
    padding-left:10px;
}
#go_ContactInfo > div > div > form > div> div.flex{
    padding: 0 2px 0 2px;
}
#go_ContactInfo > div > div > form > div > div.flex > div > div > div.v-input__slot{
    height: 52px;
}
</style>